import React from 'react';

/**
 *  PopupContent is a div styled with props, that renders its children.
 *  Popup renders its children through a React Portal. PopupContent
 *  has a fixed position directly aligned with the to the top right corner
 *  of the FieldMenu rectangle it is associatd with.
 *
 *  @reactProps {string} top - the top position for PopupContent (should be the top of the FieldMenu rectangle)
 *  @reactProps {string} left - the left position for PopupContent
 *              (should be the right coordinate + 5px of the FieldMenu rectangle)
 *  @reactProps {HTML Element} children - JSX for PopupContent to render.
 */
export default class PopupContent extends React.Component {
  /**
   * PopupContent renders its child props.
   * @return div > this.props.children
   */
  render() {
    return (
      <div
        className="popup-content"
        style={{
          position: 'fixed',
          top: `${this.props.top}px`,
          left: `${this.props.left}px`,
          bottom: '0px',
          right: '0px'
        }}
      >
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PopupContent.js